module.exports = __webpack_public_path__ + "static/media/11.b87e0be8.JPG";